"use client";
import { useMemo } from "react";
import { usePathname } from "next/navigation";
import { Body2 } from "@/styles/theme/components/typography.fontvariant";
import MLink, { MLinkProps } from "@cc/m-link";
import { NavigateNextRounded } from "@mui/icons-material";
import { Stack, StackProps } from "@mui/material";
import { deepmerge } from "@mui/utils";
import { startCase } from "lodash";

export interface ReactiveBreadcrumbProps extends Omit<StackProps, "children"> {
  MLinkProps?: Omit<MLinkProps, "href" | "children">;
}

const ReactiveBreadcrumb = (props: ReactiveBreadcrumbProps) => {
  const { MLinkProps, ...restStackProps } = props;
  const pathName = usePathname();

  const pathNames = useMemo(() => {
    const paths = pathName.split("/").slice(1);
    return ["home", ...paths];
  }, [pathName]);

  const mLinkProps = useMemo(
    () =>
      (isLast: boolean): ReactiveBreadcrumbProps["MLinkProps"] => {
        return deepmerge(
          {
            disableRipple: true,
            variant: "text",
            color: "inherit",
            sx: {
              fontSize: Body2,
              opacity: isLast ? 1 : 0.5,
              pointerEvents: isLast ? "none" : "auto",
              whiteSpace: "break-spaces",
              "&:hover": {
                textDecoration: isLast ? "none" : "underline",
              },
            },
          },
          MLinkProps,
        );
      },
    [MLinkProps],
  );

  return (
    <Stack
      component={"nav"}
      direction={"row"}
      alignItems={"center"}
      flexWrap={"wrap"}
      sx={{ color: "inherit" }}
      divider={<NavigateNextRounded sx={{ opacity: 0.5 }} fontSize="small" />}
      {...restStackProps}
    >
      {/* {!pathNames.includes("hi") && pathNames.map((item, index, arr) => { */}
      {pathNames.map((item, index, arr) => {
        if (!item) return;
        if (unLinkedRoutes.includes(item)) return;
        const path = arr.slice(1, index + 1).join("/");
        const isLast = arr.length === index + 1;

        return (
          <MLink
            key={index}
            href={`/${path}`}
            disableLocale={!!index}
            {...mLinkProps(isLast)}
          >
            {startCase(item)}
          </MLink>
        );
      })}
    </Stack>
  );
};

export default ReactiveBreadcrumb;

const unLinkedRoutes = [
  "our-companies",
  "charitable-trusts",
  "initiatives",
  "case-studies",
  "blogs",
  "press-release",
  "hi",
];
